module.exports = __webpack_public_path__ + "static/media/AreYouSelfEmployed.622b4d7c.svg";